<template>
  <!-- 此模块为会员跨市提醒弹框 -->
  <div class="SpanCityRemindDialog">
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="top flex">
          <div class="close " @click="showDialog=false">
            <img src="../../assets/images/hisTrack/clear.png" alt="" srcset="">
          </div>
        </div>
        <div class="header flex">
          <div class="header-img">
            <img class="title-img" src="../../assets/images/hisTrack/span-city-title.png" alt="">
            <img class="new-img" src="../../assets/images/hisTrack/new.png" alt="" srcset="">
          </div>
          <div class="header-title">
            <div>货车跨越城市</div>
            <div>微信收到提醒</div>
          </div>
        </div>
        <p>1.通过卫星监控，货车跨越城市边界时提醒</p>
        <p>2.每次设置跨市提醒，仅持续到当日24点。如需继续跟踪，请在第二天重新设置。</p>
        <!-- <p>3.关注“海管家”公众号，才能接收到微信推送。 </p> -->
        <p>3.该功能仅供至尊会员免费，如需使用请开通至尊会员。 </p>
        <div class="btn flex" @click="showDialog=false">我知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      showDialog: false
    };
  },
  methods: {
    showPopup () {
      this.showDialog = true
    },
  },
};
</script>

<style scoped lang="scss">
.SpanCityRemindDialog>:nth-child(1) {
  background-color: rgba(0,0,0,.4)
}
.SpanCityRemindDialog>:nth-child(2) {
  border-radius: 12px;
  width: 80%
}
.SpanCityRemindDialog {
  .close {
    margin-left: auto;
    width: 32px;
    height: 32px;
    img {
      width: 100%;
    }
  }
  .content {
    padding: 30px 30px;
    background-color: #ffffff;
    .header {
      margin-bottom: 20px;
      .header-img {
        position: relative;
        padding-left: 60px;
        .title-img {
          width: 120px;
        }
        .new-img {
          width: 36px;
          position: absolute;
          right: -2px;
          top: -10px;
        }
      }
      .header-title {
        padding-left: 40px;
        padding-top: 10px;
        color: #282828;
        font-size: 32px;
        :last-child {
          padding-top: 10px;
        }
      }
    }
  }
  p {
    color: #656565;
    font-size: 24px;
    padding-bottom: 10px;
  }
  .btn {
    background-color: #5277FF;
    color: #ffffff;
    height: 80px;
    border-radius: 40px;
    margin-top: 30px;
    justify-content: center;
    align-items: center;
  }
}
</style>
